import formatTeam from "../format/team";
import queryByDocType from "../queryByDocType";

export default async () => {
	const team = await queryByDocType("team_member");
	return team.map(formatTeam);
};
